import { computed, reaction, observable, action } from 'mobx';
import { isIPhone } from '../helpers/browser-detection';

class UI {
    constructor() {
        reaction(
            () => this._fullscreen,
            (fullscreen) => {
                window.scrollTo(0, 1);
            },
        )
    }

    @observable
    _locale = window.localStorage.locale || 'es';

    @observable
    _fullscreen = false;

    @observable
    _gameIsVisible = true;

    @computed
    get locale() {
        return this._locale;
    }

    @computed
    get gameIsVisible() {
        return this._gameIsVisible;
    }

    @computed
    get fullscreen() {
        return isIPhone() && this._fullscreen;
    }

    @action
    setFullscreen(fullscreen) {
        this._fullscreen = +fullscreen;
    }

    @action
    setGameIsVisible(status){
        this._gameIsVisible = +status;
    }

}

export default new UI();
